import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from '../../utils/TestIds';
import { Loader } from '../Loader';
import styles from './GlobalLoader.module.scss';
import { OverlayLoaderTID } from './OverlayContext';
export const GetGlobalLoaderTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            GlobalLoaderTID: {
                Root: 'global-loader'
            }
        }
    });
export function GlobalLoader() {
    const { GlobalLoaderTID } = useMemo(()=>GetGlobalLoaderTID(), []);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.globalLoader,
        "data-testid": GlobalLoaderTID.Root(),
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": OverlayLoaderTID,
                className: styles.overlay
            }),
            /*#__PURE__*/ _jsx(Loader, {})
        ]
    });
}
